import React, { useEffect, useState } from "react";
import Select from "react-select";

/**
 * Componente reutilizable para manejar dropdown con busqueda
 * !Si se desea trabajar con selecccion multiple usar el componente CustomMultipleSelect
 */
export default function CustomSelect({
  items,
  name,
  placeholder,
  item,
  customChangeHandler,
  setValue, // for useform hook, is optional
  errors, // for useform hook, is optional
  register, // for useform hook, is optional
}) {
  const [model, setModel] = useState();
  const handleChange = async (event) => {
    let selected;

    if (setValue) {
      setValue(name, event?.id, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    }

    selected = items.find((e) => e.id == event?.id);

    setModel(selected);

    if (customChangeHandler != undefined) {
      customChangeHandler(event);
    }
  };

  useEffect(() => {
    if (item) {
      if (setValue) {
        setValue(name, item[name], {
          shouldDirty: false,
          shouldTouch: true,
          shouldValidate: true,
        });
      }

      let selected = items.find((e) => e.id == item[name]);

      if (selected) {
        setModel(selected);
      }
    }
  }, [items, item]);

  return (
    <>
      <Select
        onChange={handleChange}
        options={items}
        search="true"
        name={name}
        placeholder={placeholder}
        isClearable="true"
        getOptionLabel={(option) => option?.name}
        getOptionValue={(option) => option?.id}
        value={model}
        className={`form-select ${errors && errors[name] && "is-invalid"}`}
      />

      <input
        type="hidden"
        name={name}
        {...(register && register(`${name}`, {}))}
        id={name}
      ></input>
    </>
  );
}
